module.exports = __webpack_public_path__ + "static/media/adp_icon.0f7c402a.png";